module.exports = __webpack_public_path__ + "img/cl.4d16f32c.png";